import * as React from "react";
import { Button } from "react-ui";

import { SPOILE_HIDE_CLICK, SPOILER_SHOW_CLICK } from "../../metricsAction";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { Icon } from "../../Icons/Icon";

import { Body, Title } from "./Spoiler.styles";

export interface SpoilerProps {
    title: string;
    children: JSX.Element;
}

export function Spoiler(props: SpoilerProps): JSX.Element {
    const track = useMetrics();
    const [showContent, setShowContent] = React.useState(false);

    const handleClick = () => {
        track(showContent ? SPOILE_HIDE_CLICK : SPOILER_SHOW_CLICK, { title: props.title });
        setShowContent(!showContent);
    };

    return (
        <div>
            <Title>
                <Button onClick={handleClick} use="link">
                    <Icon name={!showContent ? "ArrowShapeTriangleARightIcon" : "ArrowShapeTriangleADownIcon"} />{" "}
                    {props.title}
                </Button>
            </Title>
            {showContent && <Body>{props.children}</Body>}
        </div>
    );
}
